import { l10n } from '@ott/l10n';
import declOfNum from '@ott/utility-decl-of-num';

const DECL_VALUES = {
  hours: ['час', 'часа', 'часов'],
  days: ['день', 'дня', 'дней'],
};

const getRoundedDuration = (duration: number, type: keyof typeof DECL_VALUES) => {
  const roundedDuration = Math.floor(duration / 0.5) * 0.5;
  const declValues = DECL_VALUES[type];
  const oneAndHalfValue = declValues[1];

  return `${roundedDuration} ${
    roundedDuration === 1.5 ? oneAndHalfValue : declOfNum(Math.floor(roundedDuration), declValues)
  }`;
};

export function getDurationText(durationMinutes: number): string {
  if (durationMinutes < 60) {
    return l10n('activityCard.durationMinutes', {
      minutes: durationMinutes,
    });
  }

  if (durationMinutes < 24 * 60) {
    const durationHours = durationMinutes / 60;

    return getRoundedDuration(durationHours, 'hours');
  }

  const durationDays = durationMinutes / (24 * 60);

  return getRoundedDuration(durationDays, 'days');
}
